const sortKeys = (v: any): any => {
  if (Array.isArray(v)) return v.map(sortKeys);
  if (typeof v === 'number') return String(v);
  if (v && typeof v === 'object') {
    return Object.keys(v).sort().reduce((acc: any, k) => {
      const val = v[k];
      if (val === '' || val === undefined) return acc;
      acc[k] = sortKeys(val);
      return acc;
    }, {});
  }
  return v;
};

export const stableStringify = (value: any): string => JSON.stringify(sortKeys(value));
